import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import CTABlock, { BaseCTABlockProps } from "./Block"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${up("laptop")} {
    flex-direction: row;
    gap: 0;
  }
`

const BlockWrapper = styled.div<{ halfWidth: boolean }>`
  width: 100%;

  ${up("laptop")} {
    width: ${({ halfWidth }) => (halfWidth ? "50%" : "100%")};
  }
`

interface InfoBlockProps {
  blocks: [BaseCTABlockProps, BaseCTABlockProps?]
}

const InfoBlock: React.FC<InfoBlockProps> = ({ blocks }) => {
  const isHalfWidth = blocks.length === 2
  return (
    <Container>
      <BlockWrapper halfWidth={isHalfWidth}>
        <CTABlock halfWidth={isHalfWidth} {...blocks[0]} />
      </BlockWrapper>
      {blocks[1] && (
        <BlockWrapper halfWidth>
          <CTABlock halfWidth {...blocks[1]} />
        </BlockWrapper>
      )}
    </Container>
  )
}

export default InfoBlock
